export default "__VITE_ASSET__BAJuzwYc__"